import React from 'react';
import Layout from '@/components/layout/Layout';
import EscortDashboardLayout from '@/components/escort-dashboard/EscortDashboardLayout';
import EscortPremiumServices from '@/components/escort-dashboard/premium/EscortPremiumServices'; // Importer le composant

const EscortPremiumPage: React.FC = () => {
  return (
    <Layout>
      <EscortDashboardLayout>
        <EscortPremiumServices /> 
      </EscortDashboardLayout>
    </Layout>
  );
};

export default EscortPremiumPage; 